import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';

import FieldRepeaterCFormik from './FieldRepeaterCFormik';
import SiteUrlField from './SiteUrlField';

const FieldRepeaterCSites = (props) => {
	const repeatShape = '';

	const linesConvertor = (name) => (_option, i) => {
		return {
			props: {
				type: FORM_LINE_TYPES.custom,
				params: {
					Component: SiteUrlField,
					name: `${name}.${i}`,
					placeholder: 'example.com',
				},
			},
		};
	};

	return (
		<FieldRepeaterCFormik
			repeatShape={repeatShape}
			linesConvertor={linesConvertor}
			{...props}
		/>
	);
};

export default FieldRepeaterCSites;
